<h1 mat-dialog-title class="pt-2 text-center">Importer des documents</h1>
<div mat-dialog-content class="p-3">

    <!-- <div class="row">
        <button appPreventDoubleClick class="m-3 col" mat-raised-button color="accent" (throttledClick)="fileInput.click()">
            <input type="file" (change)="onFileChange($event)" [accept]="Accept" placeholder="Proposition de stratégie"
                #fileInput multiple>
            <mat-icon aria-label="add-image">cloud_upload</mat-icon> Parcourir les fichiers
        </button>
    </div> -->
    <div *ngIf="WithInputText" class="row">
        <mat-form-field class="w-100">
            <mat-label>{{InputLabel}}</mat-label>
            <input matInput [placeholder]="InputLabel" [(ngModel)]="Code">
        </mat-form-field>
    </div>

    <div *ngIf="!coreData.IsMobile" class="row">
        <div class="m-3 d-flex align-items-center justify-content-center col uploadfilecontainer"
            (click)="fileInput4DnD.click()" appDragDrop (onFileDropped)="onFileFromDragNDrop($event)">
            <input type="file" #fileInput4DnD (change)="onFileFromDragNDrop($event.target)" [multiple]="IsMultiple">
            <mat-icon class="mr-1" aria-label="add-image">cloud_upload</mat-icon> Déposer un fichier
        </div>
    </div>

    <div class="row">
        <div class="col-1 mx-auto">
            <circle-progress *ngIf="PercentDone !== 0 && PercentDone !== 101" [percent]="PercentDone"
                [backgroundPadding]="1" [radius]="20" [space]="-2" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="3"
                [outerStrokeColor]="'#f50057'" [outerStrokeWidth]="3" [animateTitle]="false" [showTitle]="true"
                [titleFontSize]="'13'" [animationDuration]="1000" [startFromZero]="false" [showSubtitle]="false"
                [showUnits]="true">
            </circle-progress>
        </div>
    </div>
    <div class="row mt-2">
        <mat-chip-list class="col" selectable="false">
            <mat-chip *ngFor="let f of Files" selectable="false" (removed)="remove(f)">
                {{f.name}}
                <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>

    <div class="row d-flex justify-content-end">
        <button appPreventDoubleClick class="col m-3" color="primary" mat-raised-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col m-3" color="primary" mat-raised-button (throttledClick)="uploadDocument()" title="SaveDocument" [disabled]="!CanAddDocument || IsLoading">
            Ajouter
        </button>
    </div>
</div>
